module.exports = __webpack_public_path__ + "img/check.417237ef.svg";